export const apiCall = async ({ entity, method, body }) => {
  try {
    let url = `${process.env.REACT_APP_END_POINT}${entity}`;

    let requestOptions = {
      method: method,
      headers: createHeader(),
      redirect: "follow",
      ...(body && { body: JSON.stringify(body) }),
    };

    let response = await fetch(url, requestOptions);

    if (response.ok) {
      // 204 doesn't have any content
      if (response.status === 204) {
        return true;
      } else {
        return await response.json();
      }
    } else {
      let result = await response.json();
      throw new Error(`${result.msg} - ${result.data}`);
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

function createHeader() {
  let header = new Headers();
  header.append("Content-Type", "application/json");
  return header;
}

export const cacheableApiCall = async ({ queryKey }) => {
  try {
    if (queryKey[0] !== undefined) {
      let url = `${process.env.REACT_APP_END_POINT}${queryKey}`;

      let requestOptions = {
        method: "GET",
        headers: createHeader(),
        redirect: "follow",
      };

      let response = await fetch(url, requestOptions);

      if (response.ok) {
        // 204 doesn't have any content
        if (response.status === 204) {
          return true;
        } else {
          return await response.json();
        }
      } else {
        let result = await response.json();
        throw new Error(`${result.msg} - ${result.data}`);
      }
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};
